import axios from "axios";
import {ILoginFormValues} from "../../../pages/auth/login/i-login";
import {API_BASE_URL_V2} from "../../../services/config";
import {normalizeV2CoachAuthResponse} from "../auth-normalizer";
import {
  getSignupTrackingParams,
  clearSignupTrackingData,
} from "../../../utils/signup-tracking";

// login standard user
export const loginStandardUserService = async (userData: ILoginFormValues) => {
  // POST /auth/login
  const response = await axios.post(API_BASE_URL_V2 + "auth/login", userData, {
    timeout: 15_000,
  });
  const result = response.data;
  return {...result, data: normalizeV2CoachAuthResponse(result.data)};
};
// get the Google consent URL to redirect the user to
export const getGoogleAuthUrlService = async () => {
  // GET /auth/google/url
  const response = await axios.get(API_BASE_URL_V2 + "auth/google/url");
  return response.data;
};
// exchange the Google code + state (from the OAuth redirect) for a session
export const googleAuthCallbackService = async (payload: {
  code: string;
  state: string;
  timeZone?: string;
}) => {
  // POST /auth/google/callback
  const trackingParams = getSignupTrackingParams();
  const response = await axios.post(API_BASE_URL_V2 + "auth/google/callback", payload, {
    params: trackingParams,
  });
  clearSignupTrackingData();
  const result = response.data;
  return {...result, data: normalizeV2CoachAuthResponse(result.data)};
};
// logout user
export const logoutUserService = async () => {
  return;
};
// verify 2FA OTP and complete login
export const verifyTwoFactorLoginService = async (payload: {
  challengeToken: string;
  twofaCode: string;
}) => {
  const response = await axios.post(API_BASE_URL_V2 + "auth/login/verify-2fa", payload);
  return response.data;
};
// resend 2FA OTP for an active login challenge
export const resendTwoFactorOtpService = async (payload: {challengeToken: string}) => {
  const response = await axios.post(
    API_BASE_URL_V2 + "auth/login/resend-2fa-otp",
    payload
  );
  return response.data;
};
